module.exports = __webpack_public_path__ + "img/samsara.17fd1dfe.svg";